import {IntlShape} from "react-intl";
import {PasswordStrengthBarScoreWords} from "peggirkit";

export const passwordMinLength = 8;
export const passwordMaxLength = 128;

export const passwordValidationLengths = (intl: IntlShape) => ({
    minLength: {
        value: passwordMinLength,
        message: intl.formatMessage({id: "mustBeMinCharacters"}, {min: passwordMinLength})
    },
    maxLength: {
        value: passwordMaxLength,
        message: intl.formatMessage({id: "mustBeMaxCharacters"}, {max: passwordMaxLength})
    },
});

export const passwordScoreWords = (intl: IntlShape): PasswordStrengthBarScoreWords => ({
    tooShort: intl.formatMessage({id: "mustBeMinCharacters"}, {min: passwordMinLength}),
    bad: intl.formatMessage({id: "weak"}),
    weak: intl.formatMessage({id: "ok"}),
    medium: intl.formatMessage({id: "good"}),
    strong: intl.formatMessage({id: "strong"})
})

export const togglePasswordVisibilityText = (visible: boolean, intl: IntlShape) =>
    intl.formatMessage({id: visible ? "hidePassword" : "showPassword"});

export const passwordFieldType = (visible: boolean) => visible ? "text" : "password";

export const passwordFieldPlaceholder = (visible: boolean) => visible ? "" : "••••••••••••••••••";
